import type { PaddlePriceIds } from "../shared/types/SubscriptionTypes";

/**
 * Get Paddle price IDs from environment variables
 * Centralized to avoid repetition across the codebase
 */
export const getPaddlePriceIds = (): PaddlePriceIds => ({
    PADDLE_STD_USER_MONTHLY_ID: import.meta.env.VITE_APP_PADDLE_STD_USER_MONTHLY_ID,
    PADDLE_STD_USER_YEARLY_ID: import.meta.env.VITE_APP_PADDLE_STD_USER_YEARLY_ID,
    PADDLE_STD_LOCATION_MONTHLY_ID: import.meta.env.VITE_APP_PADDLE_STD_LOCATION_MONTHLY_ID,
    PADDLE_STD_LOCATION_YEARLY_ID: import.meta.env.VITE_APP_PADDLE_STD_LOCATION_YEARLY_ID,
});